module.exports = __webpack_public_path__ + "favicon.b068e8a7.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 981
// module chunks = 0